import { SendAnalytics, GenerateLabel } from "../main";

const analyticsConnection = SendAnalytics('no connection')
const analyticsUpgrade = SendAnalytics('upgrade pop up')

/** 👇 Users acces emtrade without connection */
const ViewNoConnection = () => analyticsConnection({
  label: GenerateLabel({}),
  action: 'no connection - view no connection alert',
  name: 'view_no_connection',
});

/** 👇 Users Click Upgrade Sekarang */
const ClickUpgrade = ({ pageName = '' }) => analyticsUpgrade({
  label: GenerateLabel({ popUpUpgrade: pageName }),
  action: 'upgrade pop up - click upgrade',
  name: 'click_upgrade',
});

const Other = { ViewNoConnection, ClickUpgrade };

export default Other;
